import React from 'react';
import AccountDeletion from './components/AccountDeletion';
import './App.css';

function App() {
  return (
    <div className="min-h-screen app flex items-center justify-center p-4">
      <AccountDeletion />
    </div>
  );
}

export default App; 